
import { Component, Vue, Prop } from 'vue-property-decorator'
import PicsUploader from '@/components/VideoUpload/index.vue'
import LogoUploader from '@/components/LogoUploader/index.vue'
import { getGroupCategoryList, setSendMessage } from '@/api/system'

@Component({
  name: 'sendMes',
  components: {
    PicsUploader,
    LogoUploader
  }
})
export default class extends Vue {
  private loading: boolean = false
  private btnLoading: boolean = false
  private groupSearch: any = ''

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 富文本编辑器
  private chatIds: any = []
  private chatIdsList: any[] = []
  private newList: any[] = []
  private sendMessage: any = ''
  private sendPhoto: any = ''
  private action: any = 'text'
  private getLogo (logo: string) {
    this.sendPhoto = logo
  }

  // 获取Telegram商户群组
  private async init () {
    try {
      this.loading = true
      let params:any = {
        page: 1,
        page_size: 100
      }
      await getGroupCategoryList(params).then((res: any) => {
        this.chatIdsList = res.results
        // this.newList = res
        this.loading = false
      })
    } catch (e) {
      console.log()
    }
  }

  private getGroupList (id, row) {
    let newArr:any = this.chatIdsList.filter(item => {
      return item.id === id
    })
    this.newList = newArr[0].group
  }

  private searchGroup (e: any) {
    this.chatIdsList.map((item: any) => {
      if (e === item.title) {
        this.chatIdsList = []
        this.chatIdsList.push(item)
      }
      if (e !== item.title && e === '') {
        this.chatIdsList = this.newList
      }
    })
  }

  selectAll() {
    if (this.chatIds.length < this.chatIdsList.length) {
      this.chatIds = []
      this.chatIdsList.map((item) => {
        this.chatIds.push(item.group)
      })
      this.chatIds.unshift('all')
    } else {
      this.chatIds = []
    }
  }
  changeSelect(val) {
    if (!val.includes('all') && val.length === this.chatIdsList.length) {
      this.chatIds.unshift('all')
    } else if (val.includes('all') && (val.length - 1) < this.chatIdsList.length) {
      this.chatIds = this.chatIds.filter((item) => {
        return item !== 'all'
      })
    }
    console.log(val)
  }
  removeTag(val) {
    if (val === 'all') {
      this.chatIds = []
    }
  }

  // 编辑 attach 弹窗
  private attachId: any = ''
  private attachUrl: any = ''
  // private attachEdit (row: any) {
  //   // this.attachVisible = true
  //   this.attachId = row.id
  //   this.attachUrl = row.attach
  // }

  // 上传图片
  private sendVideo: any = ''
  private getPicList (fileList: any) {
    this.sendVideo = fileList
  }

  private changeMode (val) {
    if (val === 'photo') {
      this.sendPhoto = ''
    } else if (val === 'video') {
      this.sendVideo = ''
    }
  }

  // private checkGroupAll: boolean = false
  // private isIndeterminateGroup: boolean = false
  // private groupCheckAllChange (val: any) {
  //   this.chatIdsList.forEach(item => {
  //     this.chatIds.push(item.chat_id)
  //   })
  //   this.chatIds = val ? this.chatIds : []
  //   this.isIndeterminateGroup = false
  // }
  // private handleCheckedGroupChange (value: any) {
  //   let checkedCount = value.length
  //   this.checkGroupAll = checkedCount === this.chatIdsList.length
  //   this.isIndeterminateGroup =
  //     checkedCount > 0 && checkedCount < this.chatIdsList.length
  // }

  private back () {
    this.chatIds = []
    this.newList = []
    this.sendMessage = ''
    this.action = 'text'
    this.sendPhoto = ''
    this.sendVideo = ''
    this.$emit('close')
  }

  private delVideo () {
    let element:any = this.$refs.delVideo
    element.videoLink = ''
    this.sendVideo = ''
  }

  private async sendSmsText (arr) {
    try {
      this.btnLoading = true
      this.flag = true
      let data: any = {}
      if (this.action === 'text') {
        data = {
          chat_ids: arr.flat(),
          message: this.sendMessage,
          action: this.action,
          msg_type: '1'
        }
      } else if (this.action === 'photo') {
        data = {
          chat_ids: arr.flat(),
          message: this.sendMessage,
          action: this.action,
          photo: this.sendPhoto,
          msg_type: '1'
        }
      } else {
        data = {
          chat_ids: arr.flat(),
          message: this.sendMessage,
          action: this.action,
          video: this.sendVideo,
          msg_type: '1'
        }
      }
      await setSendMessage(data).then(() => {
        this.$message({
          message: 'Operation is successful!',
          type: 'success'
        })
        this.btnLoading = false
        this.flagStr()
      })
    } catch (e) {
      this.btnLoading = false
      this.flagStr()
    }
  }

  private editorSave () {
    let arr:any = []
    arr = JSON.parse(JSON.stringify(this.chatIds))
    arr = arr.filter((item:any) => {
      return item.length !== 0
    })
    if (this.chatIds.includes('all')) {
      arr.splice(arr.indexOf('all'), 1)
    } else {
      arr = this.chatIds
    }
    arr = arr.flat(Infinity)
    this.sendSmsText(arr)
  }

  // created () {
  //   this.getTelegroupList()
  // }
}
